import { TServerDeTectFaceData, TSwap } from "@/types";
import { cropImage, expandFace, getRandomId, imageLoader } from ".";

export async function faceToSwap(
  faces: TServerDeTectFaceData[],
  fromUrl: string
) {
  const img = await imageLoader(fromUrl);
  let swapList: TSwap[] = faces.map((item) => {
    const [x1, y1, x2, y2] = item.bbox;
    const width = x2 - x1;
    const height = y2 - y1;
    const newFace = expandFace(
      {
        width: img.width,
        height: img.height,
      },
      {
        x: x1,
        y: y1,
      },
      {
        width,
        height,
      }
    );
    return {
      id: getRandomId(),
      source: {
        area: width * height,
        resource: {},
        dimension: {
          width: newFace.dimensions.width,
          height: newFace.dimensions.height,
        },
        coordinate: {
          x: newFace.coordinate.x,
          y: newFace.coordinate.y,
        },
      },
    };
  });
  console.log("swapList", JSON.stringify(swapList));
  swapList.sort((a, b) => (b.source.area || 0) - (a.source.area || 0)); // 按面积排序
  console.log("swapList", JSON.stringify(swapList));
  swapList =  swapList.slice(0, 5);
  await Promise.all(
    swapList.map((item) => {
      const { source } = item;
      const { dimension, coordinate } = source;
      const { width = 0, height = 0 } = dimension || {};
      const { x = 0, y = 0 } = coordinate || {};
      return cropImage(fromUrl, x, y, width, height).then((res) => {
        item.source.resource.file = res;
        item.source.resource.blobUrl = URL.createObjectURL(res);
      });
    })
  );

  return swapList;
}

/** 获取面积最大的人脸并裁剪 */
export async function getMaxFaceAndCrop(
  faces: TServerDeTectFaceData[],
  fromUrl: string
) {
  const swapList: TSwap[] = faces.map((item) => {
    const [x1, y1, x2, y2] = item.bbox;
    return {
      id: getRandomId(),
      source: {
        resource: {},
        dimension: {
          width: x2 - x1,
          height: y2 - y1,
        },

        coordinate: {
          x: x1,
          y: y1,
        },
      },
    };
  });
  const areas = swapList.map((item) => {
    const { dimension } = item.source;
    const { width = 0, height = 0 } = dimension || {};
    return width * height;
  });
  const maxIndex = areas.indexOf(Math.max(...areas));
  const maxFace = swapList[maxIndex];
  const { source } = maxFace;
  const { dimension, coordinate } = source;
  const { width = 0, height = 0 } = dimension || {};
  const { x = 0, y = 0 } = coordinate || {};
  const file = await cropImage(fromUrl, x, y, width, height);
  return file;
}
